export const isPromise = <T>(
  response: Promise<T> | T | undefined
): response is Promise<T> =>
  response ? typeof (response as Promise<T>).then === 'function' : false;
